export const API_BASE_URL = 'https://bevogtet.com/dashboard-api/api';
export const ADMIN_BASE_URL = 'https://bevogtet.com/dashboard-api/admin';

// export const API_BASE_URL = 'http://localhost:5002/dashboard-api/api';
// export const ADMIN_BASE_URL = 'http://localhost:5002/dashboard-api/admin';

export const STRIPE_PUBLISHABLE_KEY =
  'pk_test_51N5av4SAHh9BgXprDapq9Dd6BdAcYhDER1IJgVvQybnIK1QeuGOoeJSIcp8bQ0IsDgZHTPshbljULvRPbqc5qBnX009i7KbQwO';
// Set to false before deploying to production to skip captcha
export const DISABLE_CAPTCHA = false;
export const RECAPTCHA_SITE_KEY = '6LezBhwtAAAAAJ9xPVMeP_e-fsedjQoFYafXbi-1';
export const LOCAL_CAPTCHA_TOKEN = 'local-dev-bypass';